import React from 'react';
import { Navigate } from 'react-router-dom';

const FinanceAccounting = () => {
  return <Navigate to="/finance/accounting/payment-requests" replace />;
};

export default FinanceAccounting;
